import React from "react";
import { Link } from "react-router-dom";
import OTMHeader from "../layout/OTMHeader";
import Title from "../layout/Title";
import {
  EnvelopeIcon,
  DocumentDuplicateIcon,
} from "@heroicons/react/24/outline";

export default function Decision() {
  return (
    <>
      <OTMHeader />
      <Title title="Select an option" settingsButton={false} />
      <div className="flex justify-center mt-16">
        <div className="flex space-x-24">
          <a
            href="https://onetrustmarketing.com/lxercmbowpozmwbdgxky/"
            className="flex flex-col items-center justify-center transition transform hover:scale-105"
          >
            <EnvelopeIcon className="w-20 h-20 mb-4 transition rounded-md text-white p-3 bg-blue-complimentary transform hover:scale-110" />
            <h1 className="text-xl font-bold text-blue-primary text-center transition-colors hover:text-green-primary">
              Email Campaigns
            </h1>
          </a>
          <Link
            to="/"
            className="flex flex-col items-center justify-center transition transform hover:scale-105"
          >
            <DocumentDuplicateIcon className="w-20 h-20 mb-4 transition rounded-md text-white p-3 bg-blue-complimentary transform hover:scale-110" />
            <h1 className="text-xl font-bold text-blue-primary text-center transition-colors hover:text-green-primary">
              Flyer Generator
            </h1>
          </Link>
        </div>
      </div>
    </>
  );
}
